declare const jQuery;

export default function map($ = jQuery) {
  const property_detail_gallery = $('#property-slider-js');
  if (property_detail_gallery.length > 0) {
    property_detail_gallery.lightSlider({
      rtl: 'no',
      gallery: true,
      item: 1,
      thumbItem: 8,
      slideMargin: 0,
      speed: 500,
      adaptiveHeight: true,
      auto: false,
      loop: true,
      prevHtml: '<button type="button" class="slick-prev slick-arrow"></button>',
      nextHtml: '<button type="button" class="slick-next slick-arrow"></button>',
      onSliderLoad: function () {
        property_detail_gallery.removeClass('cS-hidden');
      }
    });
  }
}
